import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteOccupationInformation: Map<string, ConfirmationData> = new Map([
    ["9b65fd68-c0db-402f-aa1b-281b083c1ece", { hidden: true }],
    ["78905547-2b78-4bf2-965e-a5a088881bb8", { hiddenAll: true }],
    ["2f6949a9-24a5-4ec1-bc58-f79b16a9a95b|4a967829-f99e-499d-bd44-91d655e894b1", { hidden: true }],
]);



